import { useQuery } from "@tanstack/react-query";

import { orpc } from "@/utils/orpc";

/** Shared by every tab: the server row plus the agent's last status (cached under one query key). */
export function useServer(id: string) {
  return useQuery({ ...orpc.servers.get.queryOptions({ input: { id } }), refetchInterval: 30_000 });
}

/** Tabs that need the agent show this when the server isn't connected. */
export function NotConnected() {
  return <p className="text-sm text-muted-foreground">The server isn't connected right now; this tab needs it.</p>;
}
